import interpolateComponents from '@automattic/interpolate-components';
import type { JSX } from 'react';
import { sprintf } from 'sprintf-js';

import type { I18nFn } from './types/I18nFn';
import type { I18nLocale } from './types/I18nLocale';

export function createI18nFn(locale: I18nLocale): I18nFn {
  return (text, ...dataArguments) => {
    const translatedText = (() => {
      if (typeof text !== 'object')
        throw new Error(`Missing i18n match for ${text}`);

      return text[locale];
    })();

    if (dataArguments.length === 0) return translatedText;

    const [data] = dataArguments;

    const keys = Object.keys(data) as unknown as (keyof typeof data)[];
    if (keys.length === 0) return translatedText;

    const args: Record<string, string | number> = {};
    const components: Record<string, JSX.Element> = {};

    for (const key of keys) {
      const value = data[key];

      if (typeof value === 'string' || typeof value === 'number')
        args[key] = value;
      else components[key] = value;
    }

    const translatedTextWithArgs = sprintf(translatedText, args);

    const hasComponents = Object.keys(components).length > 0;
    if (!hasComponents) return translatedTextWithArgs;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return interpolateComponents({
      mixedString: translatedTextWithArgs,
      components,
    });
  };
}
